import React, { useContext, useState } from 'react';
import { Modal as ModalModule, UI } from 'common';
import isArray from 'lodash/isArray';

import ContactsCommunication from '../utils/ContactsCommunication';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { WrappedDropdownWithLabel } = UI;

const ChangeCostCodeModal = ({
	data: { costCodes, selectedContacts, updateContactsState, fetchContacts },
	modalId,
}) => {
	/**
	 * Process selectedContacts array to find the initial cost code id.
	 * The initial id will be the same id of all CostCodeIds in selectedContacts,
	 * assuming if it's not 0. If all CostCodeIds are 0, the initial id
	 * will be -1. In the case of inconsistent CostCodeIds in selectedContacts
	 * array, the initial id will be -1. -1 is to select "None" in the dropdown.
	 */
	const initialCostCodeId = isArray(selectedContacts)
		? selectedContacts.reduce((_id, contact) => {
				if (contact.CostCodeId !== 0 && _id !== -1) {
					return contact.CostCodeId;
				}

				return contact.CostCodeId === 0 ? -1 : _id;
		  }, null)
		: -1;

	const { showError, closeModal } = useContext(ModalContext);
	const [costCodeId, setCostCodeId] = useState(initialCostCodeId);

	const handleInputChange = ({ target: { value } }) => {
		setCostCodeId(value);
	};

	const associateCostCode = async () => {
		const data = { costCodeId };

		if (selectedContacts.length === 1) {
			data.contactId = selectedContacts[0].ContactId;
			data.allSelected = false;
		} else {
			data.contacts = selectedContacts.map(contact => contact.ContactId);
			data.allSelected = true;
		}
		const response = await ContactsCommunication.costCodeAssociations(data);

		if (ContactsCommunication.isSuccessful(response)) {
			const selectedCostCode = costCodes.filter(costCode => costCode.id === costCodeId);

			if (selectedCostCode && selectedCostCode[0]) {
				updateContactsState(
					{
						CostCodeId: selectedCostCode[0].id,
						CostCode: selectedCostCode[0].name,
					},
					true
				);
			}

			fetchContacts();
			closeModal(modalId, ModalButtonActionType.Ok);
		} else {
			showError({ response });
		}
	};

	const onSaveButtonClick = () => {
		associateCostCode();
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Save',
		onClick: onSaveButtonClick,
		dataqa: 'change-cost-code-save-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="contacts contacts-change-cost-code-modal"
			header="Change Cost Code"
			primaryButton={primaryButton}
			size="small"
		>
			<div className="body">
				<WrappedDropdownWithLabel
					className="dropdown p-col-12"
					label="New Cost Code:"
					uiElementConfig={{
						value: costCodeId,
						name: 'costCodeId',
						options: costCodes,
						optionLabel: 'name',
						optionValue: 'id',
						dataqa: 'costcodeid',
						onChange: handleInputChange,
					}}
				/>
			</div>
		</Modal>
	);
};

export default ChangeCostCodeModal;
